export const MINIMUM_LUMP_SUM_SELECTED = 'MINIMUM_LUMP_SUM_SELECTED'
export const MINIMUM_MONTHLY_DEBIT_ORDER_SELECTED = 'MINIMUM_MONTHLY_DEBIT_ORDER_SELECTED'
export const events = {
  edit: {
    start: 'START_EDITING_INVESTMENT_MINIMUMS',
    stop: 'STOP_EDITING_INVESTMENT_MINIMUMS',
    cancel: 'CANCEL_EDITING_INVESTMENT_MINIMUMS'
  },
  set: {
    minimumLumpSum: 'SET_INVESTMENT_MINIMUMS_MINIMUM_LUMP_SUM',
    minimumMonthlyDebitOrder: 'SET_INVESTMENT_MINIMUMS_MINIMUM_MONTHLY_DEBIT_ORDER',
    allowUnsureInvestors: 'SET_INVESTMENT_MINIMUMS_ALLOW_UNSURE_INVESTORS'
  }
}

const { edit, set } = events
export const actions = {
  edit: {
    start: () => ({
      type: edit.start
    }),
    stop: () => ({
      type: edit.stop
    }),
    cancel: () => ({
      type: edit.cancel
    })
  },
  set: {
    minimumLumpSum: (minimumLumpSum) => ({
      type: set.minimumLumpSum,
      minimumLumpSum
    }),
    minimumMonthlyDebitOrder: (minimumMonthlyDebitOrder) => ({
      type: set.minimumMonthlyDebitOrder,
      minimumMonthlyDebitOrder
    }),
    allowUnsureInvestors: (allow) => ({
      type: set.allowUnsureInvestors,
      allow
    })
  }
}

export const minimumLumpSumSelected = minimumLumpSumSelected => ({
  type: MINIMUM_LUMP_SUM_SELECTED,
  minimumLumpSumSelected
})

export const minimumMonthlyDebitOrderSelected = minimumMonthlyDebitOrderSelected => ({
  type: MINIMUM_MONTHLY_DEBIT_ORDER_SELECTED,
  minimumMonthlyDebitOrderSelected
})
